import React, { memo, useContext } from 'react'
import { AudioContext } from 'rewact'
import { areEqual } from 'react-window'
import cn from 'classnames'

import * as Icon from '../Icons'
import { Loader as LoaderIcon } from '../Icons'
import { useDelayedState } from '../../hooks'

import styles from './app.module.css'

function TracksItem({ index, style, data }) {
  const { isPaused, play, pause } = useContext(AudioContext)
  const [isReallyPaused] = useDelayedState(
    isPaused,
    process.env.NODE_ENV === 'production' ? 300 : 100
  )
  const {
    items,
    playerTrack,
    setPlayerTrack,
    selectionState,
    toggleSelection,
    filter,
    isItemLoaded,
  } = data
  const loaded = isItemLoaded(index)
  const item = items[index] || {
    id: null,
    artist: '',
    name: '',
    slug: '',
    image: null,
  }

  const active = item.slug === playerTrack.slug

  function setCurrentTrack(e) {
    e.preventDefault()
    e.stopPropagation()
    if (!active) {
      setPlayerTrack({
        slug: item.slug,
        name: item.name,
        artist: item.artist,
        id: item.id,
        image: item.image,
      })
      setTimeout(play, 100)
    } else {
      if (isReallyPaused) {
        play()
      } else {
        pause()
      }
    }
  }
  return loaded ? (
    <div
      style={{
        ...style,
        width: `calc(${style.width} - 25px)`,
        paddingBottom: 10,
      }}
    >
      <div
        className={cn(styles.tracksPlayerItem, {
          [styles.active]: active,
        })}
        onClick={setCurrentTrack}
        role="button"
        tabIndex={0}
      >
        <div className={styles.tracksPlayerImage}>
          <img
            alt={`${item.name} by ${item.artist}`}
            src={
              item.image
                ? `${process.env.REACT_APP_COVER_URI}/s/${item.image}`
                : require('../../images/placeholder.jpg')
            }
            className={styles.tracksPlayerImageImg}
          />

          <div className={styles.tracksPlayerImagePlayBtn}>
            {active && !isReallyPaused ? (
              <Icon.Pause />
            ) : (
              <Icon.Play style={{ marginLeft: 2 }} />
            )}
          </div>
        </div>
        <div className={styles.tracksPlayerInfo}>
          <p className={styles.tracksPlayerInfoName}>{item.name}</p>
          <p
            className={styles.tracksPlayerInfoArtist}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              filter('artist', item.artist, false)
            }}
          >
            {item.artist}
          </p>
        </div>
        <div className={styles.tracksPlayerGenres}>
          {item.genre?.map((genre) => (
            <span key={`genre_${genre}`} className={styles.tracksPlayerGenre}>
              <button
                className={styles.tracksPlayerGenreButton}
                key={`${item.id}${genre}`}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  filter('genre', genre, false)
                }}
              >
                {genre}
              </button>
            </span>
          ))}
        </div>
        <div className={styles.tracksPlayerActions}>
          <button
            className={cn(styles.tracksPlayerActionBtn, {
              [styles.active]: selectionState[item.slug],
            })}
            title="Add to Favorites"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              toggleSelection(item)
            }}
          >
            <Icon.AddToSelection />
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div
      style={{
        ...style,
        width: `calc(${style.width} - 25px)`,
      }}
      className={cn(styles.tracksPlayerItem, styles.tracksLoader)}
    >
      <LoaderIcon className={styles.loaderIcon} />
    </div>
  )
}

export default memo((props) => <TracksItem {...props} />, areEqual)
